"use client";

import { ImageShowcase } from "@/app/(marketing)/components/demo/showcases/ImageShowcase";
import { StarPoint } from "@/app/(marketing)/components/demo/showcases/StarPoint";
import { ButtonLink } from "@/components/buttons/ButtonLink";
import screenshot from "@/public/images/appScreenshots/train-voice.png";

export function TrainVoiceShowcase() {
  return (
    <ImageShowcase
      screenshot={screenshot}
      headingText="Train voice"
      altText="Screenshot of train ai singing voice generator page"
    >
      <ul className="flex flex-col gap-y-2">
        <StarPoint>
          Create an AI voice using 10-15 minutes of recorded vocals
        </StarPoint>
      </ul>
      <ButtonLink
        external={false}
        href="/my-voices"
        className="mt-6 block w-fit"
      >
        Explore
      </ButtonLink>
    </ImageShowcase>
  );
}
